import styled from 'styled-components'
import Box from 'components/shared/Box'

export const Wrapper = styled(Box)`
    & > ${Box} {
        border: 2px solid
            ${({ theme }) =>
                theme.mode === 'dark'
                    ? theme.colors.grayscale_100
                    : theme.colors.grayscale_300};
        border-radius: 8px;
    }
`
export const Creator = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_100};
`
export const OriginalCabana = styled(Box)`
    border-bottom: 2px solid ${({ theme }) => theme.colors.grayscale_300};
`
